const TZ_PORTS = [
  { label: "Arusha Airport (Air)", value: "37" },
  { label: "Kilimanjaro International Airport, KIA (Air)", value: "38" },
  { label: "Dar es Salaam - Julius Nyerere International Airport, JNIA (Air)", value: "40" },
  { label: "Mwanza International Airport (Air)", value: "46" },
  { label: "Abeid Amani Karume International Airport (Air)", value: "51" },
  { label: "Namanga (Land)", value: "53" },
  { label: "Sirari (Land)", value: "57" },
  { label: "Tarakea (Land)", value: "58" },
  { label: "Holili (Land)", value: "59" },
  { label: "Horohoro (Land)", value: "60" },
  { label: "Kasumulu (Land)", value: "66" },
  { label: "Rusumo (Land)", value: "73" },
  { label: "Mtukula (Land)", value: "76" },
  { label: "Tunduma (Land)", value: "79" },
  { label: "Zanzibar Seaport (Sea)", value: "99" },
  { label: "Wesha Seaport (Sea)", value: "119" }
]

export const TZ_FIELDS = {}

export const TZ_APPLICATION_FIELDS = {
  destination: {
    type: 'select',
    props: {
      label: 'Destination',
      options: [
        { label: 'Tanzania Mainland', value: '1' },
        { label: 'Zanzibar', value: '2' }
      ]
    }
  },
  entry_type: {
    type: 'buttons',
    props: {
      options: [
        { icon: 'icon-air', label: 'Air', value: 'air' },
        { icon: 'icon-sea', label: 'Sea', value: 'sea' },
        { icon: 'icon-land', label: 'Land', value: 'land' }
      ]
    }
  },
  entry_port: {
    type: 'autocomplete',
    props: {
      label: 'Port of Entry',
      options: TZ_PORTS
    }
  },
  exit_port: {
    type: 'autocomplete',
    props: {
      label: 'Port of Departure',
      options: TZ_PORTS
    }
  },
  first_time: {
    answer: {
      type: 'yes-no-buttons'
    }
  },
  last_visit_date: {
    type: 'datepicker',
    props: {
      view: 'multi-year',
      label: 'Last Visit Date',
      before: [
        {
          date: 'now',
          message: 'Date can’t be in the future'
        }
      ]
    }
  },
  last_visa_number: {
    type: 'input',
    props: {
      label: 'Last Visa Number',
      maxLength: 50
    }
  },
  host: {
    type: {
      type: 'select',
      props: {
        label: 'Type of Host',
        options: [
          { label: 'Tanzania Citizen', value: '1' },
          { label: 'Company/Organization', value: '2' },
          { label: 'Self', value: '3' },
          { label: 'Resident with Pass', value: '4' },
          { label: 'Resident with Permit', value: '5' }
        ]
      }
    },
    name: {
      type: 'input',
      props: {
        label: 'Host Name',
        maxLength: 50
      }
    },
    id: {
      type: 'input',
      props: {
        label: 'NIN (National ID Number)',
        maxLength: 50
      }
    },
    pass_number: {
      type: 'input',
      props: {
        label: 'Pass / Permit Number',
        maxLength: 50
      }
    },
    company: {
      type: 'input',
      props: {
        label: 'Company / Office',
        maxLength: 50
      }
    },
    phone_number: {
      type: 'input',
      props: {
        label: 'Host Phone Number',
        maxLength: 50
      }
    },
    email: {
      type: 'input',
      props: {
        label: 'Host Email',
        pattern: `\\w+([\\-+._']\\w+)*@\\w+([\\-._]\\w+)*\\.\\w+([\\-.]\\w+)*`,
        maxLength: 100
      }
    },
    relationship: {
      type: 'input',
      props: {
        label: 'Relationship to Host',
        maxLength: 50
      }
    },
    address: {
      type: 'input',
      props: {
        label: 'Host Address',
        maxLength: 200
      }
    }
  },
  accomodation: {
    type: {
      type: 'select',
      props: {
        label: 'Accommodation Type',
        options: [
          { label: 'Hotel', value: '1' },
          { label: 'Motel', value: '2' },
          { label: 'Apartment', value: '3' },
          { label: 'Private Residence', value: '4' }
        ]
      }
    },
    address: {
      type: 'input',
      props: {
        label: 'Accommodation Address',
        maxLength: 200
      }
    }
  },
  return_confirmation: {
    props: {
      type: 'pdf_document',
      message: 'Please take a picture or upload a copy of your return ticket or travel confirmation.',
      friendly_name: 'Return Travel Confirmation'
    }
  }
}
